<template>
    <div class="wrapper">
        <page-header/>
        <div class="section">
            <div class="container">
                <h2 class="text-center">訂單明細</h2>
                <div class="row">
                    <div class="col-md-5">
                        <img class="d-block img-raised"
                             :src="orderDetail.product.cover_image.path"/>
                    </div>
                    <div class="col-md-6 ml-auto mr-auto">
                        <p class="category">訂單編號：{{ orderDetail.order_number }}</p>
                        <p class="category">訂單日期：{{ orderDetail.ordered_at | dateFormat }}</p>
                        <p class="category">狀態：{{ orderDetail.status | orderState }}</p>
                        <p v-if="orderDetail.status === 'lackOfDocument'" class="category">缺件說明：{{ orderDetail.lack_of_document_description }}</p>
                        <p v-if="orderDetail.status === 'canceled'" class="category">取消原因：{{ orderDetail.cancel_reason }}</p>
                        <p class="category">購買商品：{{ orderDetail.product.name }}</p>
                        <p class="category">付款連結：<a :href="orderDetail.payment_url">{{ orderDetail.payment_url }}</a></p>
                        <div class="price">月付 <strong>NT$ {{ orderDetail.period_amount }}</strong> * {{ orderDetail.period_count }}期</div>
                    </div>
                </div>
                <hr class="my-5">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="info-group">
                            <div class="info-title">收件人姓名</div>
                            <div class="info-content">{{ orderDetail.recipient.name }}</div>
                        </div>
                        <div class="info-group">
                            <div class="info-title">收件人電話</div>
                            <div class="info-content">{{ orderDetail.recipient.phone_number }}</div>
                        </div>
                        <div class="info-group">
                            <div class="info-title">收件人地址</div>
                            <div class="info-content">{{ orderDetail.recipient.county }}{{ orderDetail.recipient.area }}{{ orderDetail.recipient.address }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PageHeader from "../partials/PageHeader";
    import {ORDER_DETAIL_QUERY} from "@/services/graphql/order";
    import {status} from '@/constants/order';
    import moment from "moment";

    export default {
        name: "OrderDetail",
        components: {
            PageHeader,
        },
        data() {
            return {
                orderDetail: {
                    recipient: {},
                    product: {
                        cover_image: {},
                    }
                }
            }
        },
        computed: {
            orderState() {
                return status[this.orderDetail.status];
            }
        },
        methods: {
            async getOrderDetail() {
                try {
                    const q = await this.$apollo.query({
                        query: ORDER_DETAIL_QUERY,
                        variables: {
                            order_id: parseInt(this.$route.params.order_id)
                        },
                        fetchPolicy: "network-only"
                    });

                    if (!q.data.orderDetail) {
                        this.$router.push({name: 'Home'});
                    }

                    this.orderDetail = q.data.orderDetail;
                } catch (err) {
                    console.error(err);
                }
            },
        },
        filters: {
            dateFormat: function (value) {
                if (value === undefined) {
                    return "";
                }
                return moment(value).format("YYYY-MM-DD HH:mm:ss");
            },
            orderState(value) {
                return status[value];
            }
        },
        created() {
            this.getOrderDetail();
        }
    }
</script>

<style scoped lang="scss">
    .custom-select {
        border-radius: 30px;
        font-size: 12px;
    }

    .info-group {
        margin-bottom: 12px;

        .info-title {
            color: #707070;
            margin-bottom: 4px;
        }

        .info-content {
            border-bottom: 1px solid #E1E1E1;
        }
    }
</style>